/**
 * @generated SignedSource<<63f4bbf6cb8d34162271edef58322584>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormattingOld_rules">;
  readonly " $fragmentType": "IssueRow";
};
export type IssueRow$key = {
  readonly " $data"?: IssueRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellsConditionalFormattingOld_rules"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "8812d49d890e1ac3ab81fdb27e0af15d";

export default node;
